// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-data-grid {
    background-color: #ffffff;
    border: 1px solid #e1e5e9;
    border-radius: 8px;
    padding: 8px;
    margin: 4px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.grid-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f3f4;
    flex-shrink: 0;
}

.registration-panel-split {
    display: flex;
    flex: 1 1;
    min-height: 0;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.registration-panel-split .grid-container {
    flex: 1 1;
    min-width: 0;
    height: 100%;
    border-radius: 8px 0 0 8px;
}

.grid-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.registration-layout-toggle {
    display: inline-flex;
    border: 1px solid #dadce0;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
}

.registration-layout-toggle-btn {
    border: none;
    background: #fff;
    color: #5f6368;
    font-size: 11px;
    font-weight: 500;
    padding: 4px 8px;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
}

.registration-layout-toggle-btn + .registration-layout-toggle-btn {
    border-left: 1px solid #dadce0;
}

.registration-layout-toggle-btn:hover {
    background: #f1f3f4;
}

.registration-layout-toggle-btn--active {
    background: #2563eb;
    color: #fff;
}

.registration-layout-toggle-btn--active:hover {
    background: #1d4ed8;
}

.registration-data-grid--navigation {
    padding: 4px;
    margin: 0;
    border-radius: 0;
    box-shadow: none;
}

.registration-data-grid--navigation .grid-header {
    margin-bottom: 4px;
    padding-bottom: 4px;
}

.registration-data-grid--navigation h3 {
    font-size: 12px;
    font-weight: 600;
}

.registration-panel-split--navigation {
    box-shadow: none;
}

.registration-panel-split--navigation .grid-container {
    border-radius: 4px;
}

.registration-data-grid--navigation .ag-header-cell,
.registration-data-grid--navigation .ag-cell {
    padding: 2px 4px;
    font-size: 12px;
}

.registration-data-grid--navigation .ag-header-cell {
    font-size: 11px;
}

.vtk-3d-button {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.vtk-3d-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.vtk-3d-button:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.registration-data-grid h3 {
    margin: 0;
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 600;
}

.theme-selector {
    display: flex;
    align-items: center;
    gap: 6px;
}

.theme-selector label {
    font-weight: 500;
    color: #5f6368;
    font-size: 12px;
}

.theme-dropdown {
    padding: 4px 8px;
    border: 1px solid #dadce0;
    border-radius: 4px;
    background-color: #ffffff;
    font-size: 12px;
    color: #3c4043;
    cursor: pointer;
    transition: all 0.2s ease;
}

.theme-dropdown:hover {
    border-color: #4285f4;
    box-shadow: 0 1px 3px rgba(66, 133, 244, 0.2);
}

.theme-dropdown:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
}

.grid-container {
    border-radius: 8px;
    overflow: auto;
    flex: 1 1;
    min-height: 0;
}

.no-data {
    color: #6c757d;
    font-style: italic;
    text-align: center;
    padding: 20px;
    margin: 0;
}

/* Custom cell styling for better readability */
.ag-cell {
    padding: 6px 10px;
    line-height: 1.3;
    font-size: 16px;
}

/* Property column styling */
.ag-cell[col-id="property"] {
    font-weight: 500;
    background-color: #f8f9fa;
    border-right: 2px solid #dee2e6;
}

/* Value column styling */
.ag-cell[col-id="value"] {
    font-family: 'Courier New', monospace;
    font-size: 16px;
    white-space: pre-wrap;
    word-break: break-word;
}

/* Header styling */
.ag-header-cell {
    font-weight: 600;
    color: #495057;
    font-size: 16px;
    padding: 8px 10px;
}

/* Pagination styling */
.ag-paging-panel {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 8px 12px;
}

/* Toolbar styling */
.ag-tool-panel {
    background-color: #f8f9fa;
    border-right: 1px solid #dee2e6;
}`, "",{"version":3,"sources":["webpack://./src/components/RegistrationDataTable/RegistrationDataGrid.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,4DAA4D;IAC5D,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yDAAyD;AAC7D;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,SAAS;AACb;;AAEA,+CAA+C;AAC/C;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA,yBAAyB;AACzB;IACI,qCAAqC;IACrC,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,+BAA+B;AACnC","sourcesContent":[".registration-data-grid {\n    background-color: #ffffff;\n    border: 1px solid #e1e5e9;\n    border-radius: 8px;\n    padding: 8px;\n    margin: 4px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.grid-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #f1f3f4;\n    flex-shrink: 0;\n}\n\n.registration-panel-split {\n    display: flex;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.registration-panel-split .grid-container {\n    flex: 1;\n    min-width: 0;\n    height: 100%;\n    border-radius: 8px 0 0 8px;\n}\n\n.grid-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.registration-layout-toggle {\n    display: inline-flex;\n    border: 1px solid #dadce0;\n    border-radius: 6px;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n\n.registration-layout-toggle-btn {\n    border: none;\n    background: #fff;\n    color: #5f6368;\n    font-size: 11px;\n    font-weight: 500;\n    padding: 4px 8px;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.registration-layout-toggle-btn + .registration-layout-toggle-btn {\n    border-left: 1px solid #dadce0;\n}\n\n.registration-layout-toggle-btn:hover {\n    background: #f1f3f4;\n}\n\n.registration-layout-toggle-btn--active {\n    background: #2563eb;\n    color: #fff;\n}\n\n.registration-layout-toggle-btn--active:hover {\n    background: #1d4ed8;\n}\n\n.registration-data-grid--navigation {\n    padding: 4px;\n    margin: 0;\n    border-radius: 0;\n    box-shadow: none;\n}\n\n.registration-data-grid--navigation .grid-header {\n    margin-bottom: 4px;\n    padding-bottom: 4px;\n}\n\n.registration-data-grid--navigation h3 {\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.registration-panel-split--navigation {\n    box-shadow: none;\n}\n\n.registration-panel-split--navigation .grid-container {\n    border-radius: 4px;\n}\n\n.registration-data-grid--navigation .ag-header-cell,\n.registration-data-grid--navigation .ag-cell {\n    padding: 2px 4px;\n    font-size: 12px;\n}\n\n.registration-data-grid--navigation .ag-header-cell {\n    font-size: 11px;\n}\n\n.vtk-3d-button {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.vtk-3d-button:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.vtk-3d-button:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.registration-data-grid h3 {\n    margin: 0;\n    color: #1a1a1a;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.theme-selector {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.theme-selector label {\n    font-weight: 500;\n    color: #5f6368;\n    font-size: 12px;\n}\n\n.theme-dropdown {\n    padding: 4px 8px;\n    border: 1px solid #dadce0;\n    border-radius: 4px;\n    background-color: #ffffff;\n    font-size: 12px;\n    color: #3c4043;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.theme-dropdown:hover {\n    border-color: #4285f4;\n    box-shadow: 0 1px 3px rgba(66, 133, 244, 0.2);\n}\n\n.theme-dropdown:focus {\n    outline: none;\n    border-color: #4285f4;\n    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);\n}\n\n.grid-container {\n    border-radius: 8px;\n    overflow: auto;\n    flex: 1;\n    min-height: 0;\n}\n\n.no-data {\n    color: #6c757d;\n    font-style: italic;\n    text-align: center;\n    padding: 20px;\n    margin: 0;\n}\n\n/* Custom cell styling for better readability */\n.ag-cell {\n    padding: 6px 10px;\n    line-height: 1.3;\n    font-size: 16px;\n}\n\n/* Property column styling */\n.ag-cell[col-id=\"property\"] {\n    font-weight: 500;\n    background-color: #f8f9fa;\n    border-right: 2px solid #dee2e6;\n}\n\n/* Value column styling */\n.ag-cell[col-id=\"value\"] {\n    font-family: 'Courier New', monospace;\n    font-size: 16px;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n/* Header styling */\n.ag-header-cell {\n    font-weight: 600;\n    color: #495057;\n    font-size: 16px;\n    padding: 8px 10px;\n}\n\n/* Pagination styling */\n.ag-paging-panel {\n    background-color: #f8f9fa;\n    border-top: 1px solid #dee2e6;\n    padding: 8px 12px;\n}\n\n/* Toolbar styling */\n.ag-tool-panel {\n    background-color: #f8f9fa;\n    border-right: 1px solid #dee2e6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
